var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9414,
    cy: 13,
    r: 13,
    fill: "#111112"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69232 6.75091C7.35777 7.08546 7.35777 7.62788 7.69232 7.96243L12.7299 13L7.69232 18.0376C7.35777 18.3721 7.35777 18.9145 7.69232 19.2491C8.02687 19.5836 8.56929 19.5836 8.90384 19.2491L13.9414 14.2115L18.979 19.2491C19.3135 19.5836 19.8559 19.5836 20.1905 19.2491C20.525 18.9145 20.525 18.3721 20.1905 18.0376L15.1529 13L20.1905 7.96243C20.525 7.62788 20.525 7.08546 20.1905 6.75091C19.8559 6.41636 19.3135 6.41636 18.979 6.75091L13.9414 11.7885L8.90384 6.75091C8.56929 6.41636 8.02687 6.41636 7.69232 6.75091Z",
    fill: "#F4F1EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDark);
export default __webpack_public_path__ + "static/media/CloseDark.822c5c0f68945895de8b0abfed090ee8.svg";
export { ForwardRef as ReactComponent };